import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import { auth } from './auth'
import { preferences } from "./preferences";
import axios from 'axios';

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: 'appData',
  storage: localStorage,
  reducer: (state) => ({
    auth: state.auth,
    preferences: state.preferences
  }) // only persist certain modules
});

const store = new Vuex.Store({
  modules: {
    auth: auth,
    preferences: preferences
  },
  plugins: [
    vuexPersist.plugin
  ],
  state: {
    logo: 'https://s3-ap-southeast-2.amazonaws.com/bcrc.io/logo.png',
    snackbar: false,
    snackbarMessage: '',
    dialog: false,
    dialogMessage: '',
    waitDialog: false,
    job: null,
    jobLoop: null,
    reasonCodeOutput: '',
    // Validation error dialog state
    validationDialog: false,
    validationErrors: null,      // Object: {field: "error message"}
    validationMessage: '',       // Main error message
    invalidFields: []            // Array of field names with errors
  },
  mutations: {
    displaySnackbar(state, message) {
      state.snackbarMessage = message;
      state.snackbar = true;
    },
    clearSnackbar(state) {
      state.snackbar = false;
      state.snackbarMessage = '';
    },

    displayDialog(state, message) {
      state.dialogMessage = message;
      state.dialog = true;
    },
    clearDialog(state) {
      state.dialog = false;
      state.dialogMessage = '';
    },

    setJob(state, job) {
      state.job = job;
    },
    setJobLoop(state, jobLoop) {
      state.jobLoop = jobLoop;
    },
    displayWaitDialog(state, boolean) {
      state.waitDialog = boolean;
    },
    displayValidationDialog(state, payload) {
      state.validationMessage = payload.message;
      state.validationErrors = payload.errors;
      state.invalidFields = Object.keys(payload.errors || {});
      state.validationDialog = true;
    },
    clearValidationDialog(state) {
      // Only close dialog, keep errors and highlighting
      state.validationDialog = false;
    },
    clearValidationErrors(state) {
      // Clear all validation state (called on successful save)
      state.validationDialog = false;
      state.validationErrors = null;
      state.validationMessage = '';
      state.invalidFields = [];
    }
  },
  getters: {
    isDev(state) {
      return process.env.NODE_ENV === "development";
    },
    jobId(state) {
      if (state.job) {
        return state.job.id;
      }
      return null;
    },
    jobStatus(state) {
      if (state.job) {
        return state.job.status_text;
      }
      return null;
    },
    jobMessage(state) {
      if (state.job) {
        if (state.job.results) {
          if (state.job.results.message !== undefined) return state.job.results.message;
        }
      }
      return null;
    },
    waitDialog: state => {
      if (state.waitDialog === null) return false;
      return state.waitDialog;
    },
    fullNameReasonCode: (state, getters) => (reasonCodeInput) => {
      if (reasonCodeInput === 'CNX') {
        state.reasonCodeOutput = 'Canceled by Vendor';
      } else if (reasonCodeInput === 'R') {
        state.reasonCodeOutput = 'Rejected by Receiver';
      } else if (reasonCodeInput === 'RREC') {
        state.reasonCodeOutput = 'Rejected by Reception';
      }else if (reasonCodeInput === 'GNR') {
        state.reasonCodeOutput = 'Goods Not Received';
      }else if (reasonCodeInput === 'G') {
        state.reasonCodeOutput = 'Goods Not Received';
      }else if (reasonCodeInput === 'DG') {
        state.reasonCodeOutput = 'Damaged Goods';
      }else if (reasonCodeInput === 'BC') {
        state.reasonCodeOutput = 'Business Closed';
      }else if (reasonCodeInput === 'BA') {
        state.reasonCodeOutput = 'Bad Address';
      }else if (reasonCodeInput === 'A') {
        state.reasonCodeOutput = 'Unable to locate address';
      }else if (reasonCodeInput === 'I') {
        state.reasonCodeOutput = 'Inaccessible drop zone';
      }else if (reasonCodeInput === 'B') {
        state.reasonCodeOutput = 'Road block / closure';
      }else if (reasonCodeInput === 'DT') {
        state.reasonCodeOutput = 'Damaged in Transit';
      }else if (reasonCodeInput === 'HO') {
        state.reasonCodeOutput = 'On Hold';
      }else if (reasonCodeInput === 'TR') {
        state.reasonCodeOutput = 'Temperature Rejection';
      } else if (reasonCodeInput === 'O') {
        state.reasonCodeOutput = 'Other';
      } else if (reasonCodeInput === 'U') {
        state.reasonCodeOutput = 'Unit Information Missing';
      }else if (reasonCodeInput === 'S') {
        state.reasonCodeOutput = 'Secure Gate / Complex';
      }else if (reasonCodeInput === 'ORC') {
        state.reasonCodeOutput = 'Cancelled by Client en route';
      }else if (reasonCodeInput === null || reasonCodeInput === '') {
        state.reasonCodeOutput = 'N/A';
      } else {
        return reasonCodeInput;
      }
      return state.reasonCodeOutput;
    },
  },
  actions: {
    displayJobDialog(context, job) {
      context.commit('setJob', job);
      context.commit('displaySnackbar', 'Started job ' + job.id);
      context.commit('displayWaitDialog', true);
      context.dispatch('jobloop');
    },
    jobloop(context) {
      context.dispatch('checkJob');
      console.log('Starting jobloop');
      context.commit('setJobLoop', setInterval(function() {
        context.dispatch('checkJob');
      }, 1000));
    },
    async checkJob(context) {
      if (context.state.job === null) return;
      return await axios.get(process.env.API_URL + '/jobs/' + context.state.job.id)
        .then((response) => {
          this.commit('setJob', response.data);
          if (response.data.status >= 3) {
            clearInterval(context.state.jobLoop);
            context.commit('displayWaitDialog', false);
            context.commit('displaySnackbar', "Job " + response.data.status_text);
          }
        })
        .catch((error) => {
          clearInterval(context.state.jobLoop);
        });
    }
  }
});

export default {
  store: store
}



// WEBPACK FOOTER //
// ./src/modules/store/index.js